// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestedUserCard-cls1_DSQ","cls2":"SuggestedUserCard-cls2_ZSs SuggestedUserCard-cls1_DSQ"};